import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { ScoreColorService } from '@maplecroft-ui/score-color';

@Component({
  selector: 'grid-ui-global-legend-expanded',
  templateUrl: './global-legend-expanded.component.html',
  styleUrls: ['./global-legend-expanded.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GlobalLegendExpandedComponent {
  protected readonly scoreColorService = inject(ScoreColorService);

  // when enabled it shows a lighter version of the index explanation.
  public readonly lite = input(false);

  protected readonly indexExplanation = computed(() => {
    let text =
      'The index score is presented on a scale of 0.00-10.00, where 0.00 represents highest risk and 10.00 represents lowest risk.';

    if (!this.lite()) {
      text += ' The risk category is based on the index score as follows:';
    }

    return text;
  });
}
